import React, { useRef } from 'react'
import { DI, DIProps } from '../../../../../Core';
import { InlineStack, Text } from '@shopify/polaris';
import { Switch } from 'antd';
import { DragIcon } from '../../../../../Asests/svgIcon/icon';
interface props extends DIProps {
    type: string
    list: any,
    setList: (data: any) => void
    productSettings: any
    setProductSettings: (data: any) => void
    errors: any
    setErrors: (val: any) => void
    onProductSettingsChange: (key: string, subKey: string, value: boolean, subKey2?: string) => void
    saveLoader: boolean
    getLoader: boolean
}

const Draggable = (props: props) => {
    const { type, list, productSettings, setProductSettings, setList, errors, setErrors, onProductSettingsChange, saveLoader, getLoader } = props;

    const dragItem = useRef<any>();
    const dragOverItem = useRef<any>();

    const dragStart = (e: any, position: any) => {
        dragItem.current = position;
    };

    const dragEnter = (e: any, position: any) => {
        dragOverItem.current = position;
    };

    const drop = (e: any, list: any, setList: (data: any) => void, key: string) => {
        let tempSettings: any = JSON.parse(JSON.stringify(productSettings));

        const copyListItems = [...list?.value];
        const dragItemContent = copyListItems[dragItem.current];
        copyListItems.splice(dragItem.current, 1);
        copyListItems.splice(dragOverItem.current, 0, dragItemContent);
        dragItem.current = null;
        dragOverItem.current = null;

        if (key && key !== '') {
            tempSettings['sync_product_with'][key]['priority'] = copyListItems;
        }
        setProductSettings(JSON.parse(JSON.stringify(tempSettings)));
        setList({ ...list, value: copyListItems });
    };

    const onChangeSwitcher = (e: boolean, priority: any) => {
        let err = JSON.parse(JSON.stringify(errors));
        if (priority == 'sku') {
            if (!productSettings?.sync_product_with?.[type]?.barcode && !e) {
                err = { ...err, [type?.toLowerCase()]: true }
            }
            else {
                err = { ...err, [type?.toLowerCase()]: false }
            }
        }
        else if (priority === 'barcode') {
            if (productSettings?.sync_product_with?.[type]?.sku === false && e === false) {
                err = { ...err, [type?.toLowerCase()]: true }
            }
            else {
                err = { ...err, [type?.toLowerCase()]: false }
            }
        }
        setErrors({ ...err })
        onProductSettingsChange("sync_product_with", type, e, priority)
    }

    return (
        <React.Fragment>
            {
                list?.value?.map((priority: any, idx: number) => {
                    return (
                        <div
                            ref={dragOverItem}
                            onDragStart={(e) => dragStart(e, idx)}
                            onDragEnter={(e) => dragEnter(e, idx)}
                            onDragEnd={(e: any) => drop(e, list, setList, type)}
                            key={priority}
                            draggable
                        >
                            <InlineStack gap="200" wrap={false}>
                                <div className='Custom-Draggable--pointer'>
                                    <DragIcon />
                                </div>
                                <Switch
                                    className='switcherBtn'
                                    size='small'
                                    id={priority === "sku" ? `product_Switch_${type}_SKU` : `product_Switch_${type}_Barcode`}
                                    checked={priority === "sku" ? productSettings?.sync_product_with?.[type]?.sku : productSettings?.sync_product_with?.[type]?.barcode}
                                    onChange={(e: boolean) => onChangeSwitcher(e, priority)}
                                    disabled={saveLoader || getLoader}
                                />
                                <div className='Custom__Line--Height'>
                                    <Text fontWeight="regular" as="p" id={priority == "sku" ? `product_Text_${type}_SKU` : `product_Text_${type}_Barcode`}>
                                        {priority === "sku" ? "SKU" : "Barcode"}
                                    </Text>
                                </div>
                            </InlineStack>
                        </div>
                    );
                })
            }
        </React.Fragment>
    );
}

export default DI(Draggable);